function showPreloader(container) {
    let $container = $(container).closest('.app-block');
    let $target = $container.find('#productTableBody');

    if ($container.find('.preloader').length === 0) {
        let $preloader = $('<div>')
            .addClass('preloader')
            .html('&nbsp;');
        $target.append($preloader);
    }
}

function hidePreloader(container) {
    $(container).closest('.app-block').find('.preloader').remove();
}

function hideAllPreloaders() {
    $('.preloader').remove();
}

function buildFilterParams(filters = {}) {
  const params = new URLSearchParams();
  for (const [key, val] of Object.entries(filters)) {
    if (Array.isArray(val)) {
      for (const v of val) params.append(`filter[${key}][]`, v);
    } else if (val !== undefined && val !== null && val !== '') {
      params.append(`filter[${key}]`, val);
    }
    //params.append('exclude_vvs1', exclude_vvs1)
  }
  return params.toString();
}

async function getPriceRange(filters = {}) {
    const qs = buildFilterParams(filters);
    const url = `${BASE_URL}/api/products/price-range/${qs ? `?${qs}` : ''}`;

    const res = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error(`Request failed: ${res.status} ${res.statusText}`);

    const json = await res.json();
    const payload = json?.data ?? json;
    return { minPrice: Number(payload.minPrice), maxPrice: Number(payload.maxPrice) };
}

async function getWeightRange(filters = {}) {
    const qs = buildFilterParams(filters);
    const url = `${BASE_URL}/api/products/weight-range/${qs ? `?${qs}` : ''}`;

    const res = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error(`Request failed: ${res.status} ${res.statusText}`);

    const json = await res.json();
    const payload = json?.data ?? json;
    return { minWeight: Number(payload.minWeight), maxWeight: Number(payload.maxWeight) };
}

async function getShapes() {
    const url = `${BASE_URL}/api/shapes`;
    const res = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error(`Request failed: ${res.status} ${res.statusText}`);

    const json = await res.json();
    const payload = json?.data ?? json;
    return payload;
}

async function getFilters(filters = {}) {
    const qs = buildFilterParams(filters);
    const url = `${BASE_URL}/api/filters/${qs ? `?${qs}` : ''}`;

    const res = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error(`Request failed: ${res.status} ${res.statusText}`);

    const json = await res.json();
    const payload = json?.data ?? json;
    return payload;
}

function buildQueryParams(params, prefix = '') {
    const qs = [];
    for (const key in params) {
        if (!params.hasOwnProperty(key)) continue;
        const value = params[key];
        const prefixedKey = prefix ? `${prefix}[${key}]` : key;

        if (Array.isArray(value)) {
            value.forEach(v => qs.push(`${encodeURIComponent(prefixedKey)}[]=${encodeURIComponent(v)}`));
        } else if (typeof value === 'object' && value !== null) {
            qs.push(buildQueryParams(value, prefixedKey));
        } else if (value !== undefined && value !== null) {
            qs.push(`${encodeURIComponent(prefixedKey)}=${encodeURIComponent(value)}`);
        }
    }
    return qs.join('&');
}

async function getProducts(productQuery = {}) {
    const qs = buildQueryParams(productQuery);
    const url = `${BASE_URL}/api/products/${qs ? `?${qs}` : ''}`;

    const res = await fetch(url, { headers: { Accept: 'application/json' } });
    
    if (!res.ok) {
        throw new Error(`Request failed: ${res.status} ${res.statusText}`);
    }

    const totalCount = res.headers.get('X-Total-Count');

    const json = await res.json();
    const data = json?.data ?? json;

    return {
        data,
        totalCount: totalCount ? parseInt(totalCount, 10) : null
    };
}

async function loadProducts(productQuery = {}, clear = false) {
    showPreloader('.table-wrapper');

    var data = await getProducts(productQuery);
    var products = data.data;
    var totalCount = data.totalCount;
    
    updateTotalCount(totalCount);

    if (!products.length || products.length < productQuery.limit) {
        hasMore = false;
    } else {
        hasMore = true;
    }

    if (clear) {
        $('#productTableBody').empty();
    }

    products.forEach(function(product) {
        if (product.variants !== undefined) {
            product.variants.forEach(function(variant) {
                var p = new Product(variant, product);
                $('#productTableBody').append(p.tr);
            });
        } else {
            var p = new Product(null, product);
            $('#productTableBody').append(p.tr);
        }
    });

    hidePreloader('.table-wrapper');
}

async function sortProducts(field, el) {
    if (!productQuery) {
        productQuery = {};
    }

    if (!productQuery.filter) {
        productQuery.filter = {};
    }

    let currentOrder = $(el).attr("data-order") || "asc";
    let newOrder = currentOrder === "asc" ? "desc" : "asc";

    $(el).attr("data-order", newOrder);

    let icon = $(el).find("i");
    if (newOrder === "asc") {
        icon.removeClass("icons-chevron-up").addClass("icons-chevron-down");
    } else {
        icon.removeClass("icons-chevron-down").addClass("icons-chevron-up");
    }

    productQuery.sort = field;
    productQuery.sort_order = newOrder.toUpperCase();

    page = 1;
    productQuery.page = page;

    console.log("Sorting by:", field, newOrder);

    await loadProducts(productQuery, true);

    unscroll();
}

function unscroll() {
    const element = document.querySelector('.table-wrapper');
    if (element) {
        element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }
}

function handleSort(selectElement) {
    const rawValue = selectElement.value;
    if (!rawValue) return;

    const [field, targetOrder] = rawValue.split('|');

    const reverseOrder = (targetOrder === 'asc') ? 'desc' : 'asc';

    const dummyElement = {
        dataset: {
            order: reverseOrder
        },
        getAttribute: function(name) {
            if (name === 'data-order') return this.dataset.order;
            return null;
        },
        setAttribute: function(name, val) {
            if (name === 'data-order') this.dataset.order = val;
        }
    };

    if (typeof sortProducts === 'function') {
        sortProducts(field, dummyElement);
    }
}

function adjustSidebarPosition() {
    const header = document.querySelector('header');
    const filterBlock = document.querySelector('.filter-block');
    
    if (header && filterBlock) {
        const headerHeight = header.offsetHeight;
        filterBlock.style.top = headerHeight + 'px';
        filterBlock.style.height = `calc(100vh - ${headerHeight}px)`;
    }
}

function updateTotalCount(count) {
    $('#total-count').text(count);
}

window.addEventListener('load', adjustSidebarPosition);
window.addEventListener('resize', adjustSidebarPosition);
adjustSidebarPosition();
